import { useReducer, useEffect, useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";

import { getListOfValues, getListSource, memberService } from "../services";

import { flitteredDropdowns } from "../utils/documentUtils";
import { reducer } from "./reducerAction";
import { initialState } from "./types";

export function useUser() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isLoading, setIsLoading] = useState(true);
  const { apiDomain } = useFlags();

  useEffect(() => {
    Promise.all([getListOfValues(apiDomain), memberService(apiDomain).get()])
      .then((promises) => {
        const [list, memberInfo] = promises;
        dispatch({
          type: "GET_MEMBER_AND_DROPDOWN",
          payload: {
            ...state,
            member: memberInfo.member,
            zendesk: memberInfo.zendesk,
            dropdowns: {
              numberOfEmployees: {
                stateName: "numberOfEmployees",
                items: flitteredDropdowns(list).sortedEmployees,
              },
              mainActivity: { stateName: "mainActivity", items: flitteredDropdowns(list).golMainActivity },
              annualBudgetforTravel: {
                stateName: "annualBudgetforTravel",
                items: flitteredDropdowns(list).sortedBusinessBudget,
              },
              occupation: { stateName: "occupation", items: flitteredDropdowns(list).golOccupation },
            },
          },
        });
      })
      .finally(() => setIsLoading(false));
    return () => {
      getListSource.cancel();
      memberService(apiDomain).memberServiceSource.cancel();
    };
  }, []);

  return { state, dispatch, isLoading };
}
